import { createColumnHelper } from '@tanstack/react-table';
import {
    ActionsCell,
    InvitationsRoleCell,
    InvitationStatusCell,
    InvitationsTeamCell,
} from './InvitationsCells';
import { Invitation } from 'generated/graphql';

const columnHelper = createColumnHelper<Invitation>();

const InvitationsColumns = [
    columnHelper.accessor('email', {
        header: 'Email',
    }),
    columnHelper.accessor('teamId', {
        header: 'Team',
        cell: InvitationsTeamCell,
    }),
    columnHelper.accessor('role', {
        header: 'Role',
        cell: InvitationsRoleCell,
    }),
    columnHelper.accessor('status', {
        header: 'Status',
        cell: InvitationStatusCell,
    }),
    columnHelper.accessor('id', {
        header: 'Actions',
        cell: ActionsCell,
    }),
];

export default InvitationsColumns;
